import ResumeBuilderEdit from "./editCandidate";

export default ResumeBuilderEdit;